import { FooterV2 } from './FooterV2';

const Renderer = ({ trackExternalLinkClick }: { trackExternalLinkClick: (arg: string) => void }) => {
  return <FooterV2 trackExternalLinkClick={trackExternalLinkClick} />;
};

export default Renderer;
